import React from 'react';
import {Route} from 'react-router-dom';
import business from './business/routes';
import consumer from './consumer/routes';
import notfound from './notfound/routes';
import perfectbeauty from './perfectbeauty/routes';
import specialRedirects from './redirects/routes';
import _flattenDeep from 'lodash/flattenDeep';
import LangGuard from '../components/router/LangGuard';

// Layer 1 routes.js files must use relative paths (a leading / throws inside the :lang nest).
// English mounts at root; other languages nest under :lang + LangGuard (whitelist), reusing the same elements.
const children = _flattenDeep([business, consumer, perfectbeauty]);
const special = _flattenDeep([specialRedirects]);
const n = _flattenDeep([notfound]);

export default () => [
  ...special,
  ...children,
  <Route key=":lang" path=":lang" element={<LangGuard />}>
    {children}
  </Route>,
  ...n,
];
